// WebSocket URL Configuration
// This logic prioritizes an environment variable, falling back to a dynamically determined URL.

export const BACKEND_WS_URL = (() => {
  // 1. Highest Priority: Environment Variable
  // Create React App requires custom environment variables to be prefixed with REACT_APP_
  // to be exposed to the browser.
  if (process.env.REACT_APP_BACKEND_WS_URL) {
    return process.env.REACT_APP_BACKEND_WS_URL;
  }

  if (process.env.BACKEND_WS_URL) {
    return process.env.BACKEND_WS_URL;
  }

  // 2. Second Priority: Auto-detection based on the browser's current location
  // This is useful for development and production environments where the frontend and backend share a domain.
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const hostname = window.location.hostname;
    
    // In a development environment (e.g., frontend at localhost:3000),
    // we'll assume the backend WebSocket is at localhost:8000.
    if (hostname === 'localhost') {
      return `${protocol}//${hostname}:8000/ws/chat`;
    }

    // In a production environment, we'll assume the WebSocket is on the same host
    // but on port 8000. Adjust if your production setup is different.
    return `${protocol}//${hostname}/ws/chat`;
  }

  // 3. Lowest Priority: Default fallback for non-browser environments
  //    This is unlikely to be used in a standard CRA app but is good practice.
  return 'ws://localhost:8000/ws/chat';
})();

// REST API Base URL
// Derived from the WebSocket URL: wss://host/ws/chat  ->  https://host/api
export const BACKEND_API_URL = (() => {
  return BACKEND_WS_URL
    .replace('wss://', 'https://')
    .replace('ws://', 'http://')
    .replace(/\/ws\/chat$/, '/api');
})();